import React, { useContext, lazy, Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "./hooks/UserContext";
import { Grid, Button, CircularProgress } from "@mui/material";
import HomeLayout from "./components/HomeLayout";
import PrivateRoute from "./PrivateRoute";

export const components = [
	{
		ID: 10,
		component: lazy(() => import("components/manageBookings/ManageBookingLanding")),
		path: "/manage-bookings",
		functionCode: ["TM_MANAGE_BOOKINGS", "MM_MANAGE_BOOKINGS", "SM_MANAGE_BOOKINGS"],
	},
	{
		ID: 11,
		component: lazy(() => import("components/manageBookings/AccessManagement.page")),
		path: "/access-management",
		functionCode: ["TM_ACCESS_MANAGEMENT", "MM_ACCESS_MANAGEMENT", "SM_ACCESS_MANAGEMENT"],
	},
	{
		ID: 1,
		component: lazy(() => import("components/Homepage/Homepage.page")),
		path: "/homepage",
		functionCode: "TM_HOMEPAGE",

		isCommonMenu: true,
	},
	// {
	//     ID: 2,
	//     component: BookSetup,
	//     path: '/book-setup',
	//     functionCode: 'SETUP',
	//     isSitReady: true
	// },
	{
		ID: 3,
		component: lazy(() => import("components/userManagement/userManagement.page")),
		path: "/user-management",
		functionCode: ["TM_USER_MANAGEMENT", "MM_USER_MANAGEMENT"], //'USER_MANAGEMENT',
	},
	// {
	// 	ID: 28,
	// 	component: lazy(() => import("components/roleManagement/RoleManagement.page")),
	// 	path: "/role-management",
	// 	functionCode: ["TM_ROLE_MANAGEMENT", "MM_ROLE_MANAGEMENT"],
	//
	// },
	{
		ID: 4,
		component: lazy(() => import("components/userManagement/changePassword.page")),
		path: "/change-password",
		functionCode: ["TM_USER_PROFILE", "SM_USER_PROFILE"],
	},
	// {
	//     ID: 5,
	//     component: SelfServeRequest,
	//     path: '/self-service-book-request',
	//     functionCode: 'ACCESS_REQUEST_SELFSERVICE',
	//     isSitReady: true
	// },
	// {
	//     ID: 6,
	//     component: CollaborateRequest,
	//     path: '/collaboration-book-request',
	//     functionCode: 'ACCESS_REQUEST_PROJECT',
	//     isSitReady: true
	// },
	{
		ID: 7,
		component: lazy(() => import("components/attendance/Attendance.page")),
		path: "/attendance-management",
		//functionCode: ["TM_ATTENDANCE_MANAGEMENT", "MM_ATTENDANCE_MANAGEMENT"],
		functionCode: ["TM_ATTENDANCE_MANAGEMENT", "MM_ATTENDANCE_MANAGEMENT"],
	},
	// {
	//     ID: 8,
	//     component: BookManagement,
	//     path: '/book-management',
	//     functionCode: 'ACCESS_MANAGEMENT',
	//     isSitReady: true
	// },
	// {
	//     ID: 9,
	//     component: ViewCapacity,
	//     path: '/book-setup/review/:selectedDate',
	//     functionCode: 'SETUP',
	//     isSitReady: true
	// },
	//{
	//	ID: 13,
	//	component: lazy(() => import("components/progressReports/researcher")),
	//	path: "/progress-reports",
	//	functionCode: ["TM_PROGRESS_REPORT", "MM_PROGRESS_REPORT", "SM_PROGRESS_REPORT"],
	//},
	//{
	//	ID: 14,
	//	component: lazy(() => import("components/progressReports/researcher/detail")),
	//	path: "/progress-reports/:id",
	//	functionCode: ["TM_PROGRESS_REPORT", "MM_PROGRESS_REPORT", "SM_PROGRESS_REPORT"],
	//},
	//{
	//	ID: 15,
	//	component: lazy(() => import("components/progressReports/admin")),
	//	path: "/progress-reports-management",
	//	functionCode: ["TM_PROGRESS_REPORT_ADM", "MM_PROGRESS_REPORT_ADM", "SM_PROGRESS_REPORT_ADM"],
	//},
	//{
	//	ID: 16,
	//	component: lazy(() => import("components/progressReports/admin/detail")),
	//	path: "/progress-reports-management/:id",
	//	functionCode: ["TM_PROGRESS_REPORT_ADM", "MM_PROGRESS_REPORT_ADM", "SM_PROGRESS_REPORT_ADM"],
	//},
	{
		ID: 17,
		component: lazy(() => import("components/projectManagement/ProjectManagement.page")),
		path: "/project-management",
		functionCode: ["TM_PROJECT_MANAGEMENT", "MM_PROJECT_MANAGEMENT", "SM_PROJECT_MANAGEMENT"],
	},
	{
		ID: 8,
		component: lazy(() => import("components/systemConfig/SystemConfig.page")),
		path: "/system-config",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 9,
		component: lazy(() => import("components/systemConfig/roleFunction/RoleManagement.page")),
		path: "/system-config/role-function",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 28,
		component: lazy(() => import("components/systemConfig/roleMenu/RoleMenu.page")),
		path: "/system-config/role-menu",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 32,
		component: lazy(() => import("components/systemConfig/roleUpload/RoleUpload.page")),
		path: "/system-config/role-upload",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 33,
		component: lazy(() => import("components/systemConfig/institutionMapping/InstitutionMapping.page")),
		path: "/system-config/institution-mapping",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 34,
		component: lazy(() => import("components/systemConfig/undertakingManagement/UndertakingManagement.page")),
		path: "/system-config/undertaking-management",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 36,
		component: lazy(() => import("components/systemConfig/serviceAgreementManagement/ServiceAgreementManagement.page")),
		path: "/system-config/service-agreement-management",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 35,
		component: lazy(() => import("components/systemConfig/inactiveUsers/InactiveUsers.page")),
		path: "/system-config/inactive-users",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 37,
		component: lazy(() => import("components/systemConfig/maintenanceNotice/MaintenanceNotice.page")),
		path: "/system-config/maintenance-notice",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 38,
		component: lazy(() => import("components/systemConfig/remoteAccessManagement/RemoteAccessManagement.page")),
		path: "/system-config/remote-access-management",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 21,
		component: lazy(() => import("components/onlineInformation/researcher/index")),
		path: "/online-information",
		functionCode: ["TM_ONLINE_INFO", "MM_ONLINE_INFO", "SM_ONLINE_INFO"],
	},
	{
		ID: 22,
		component: lazy(() => import("components/onlineInformation/admin/index")),
		path: "/online-information-management",
		functionCode: ["TM_SYSTEM_CONFIG", "MM_SYSTEM_CONFIG", "SM_SYSTEM_CONFIG"],
	},
	{
		ID: 23,
		component: lazy(() => import("components/dataServices/DataServicesLanding")),
		path: "/data-services",
		functionCode: ["TM_DATA_SERVICES", "MM_DATA_SERVICES", "SM_DATA_SERVICES"],
	},
	{
		ID: 24,
		component: lazy(() => import("components/dataServices/EXPERT/EXPERTLanding")),
		path: "/data-services/expert",
		functionCode: ["DATA_SERVICES_EXPERT"],
	},
	{
		ID: 34,
		component: lazy(() => import("components/dataServices/EXPERT/ExpertCalculator.page")),
		path: "/data-services/expert-calculator",
		functionCode: ["TM_DATA_SERVICES", "MM_DATA_SERVICES", "SM_DATA_SERVICES", "MM_EXPERT_CALCULATOR"],
	},
	{
		ID: 25,
		component: lazy(() => import("components/applicationManagement/ApplicationManagement.page")),
		path: "/application-management",
		functionCode: ["TM_APPLICATION_MANAGEMENT", "MM_APPLICATION_MANAGEMENT", "SM_APPLICATION_MANAGEMENT"],
	},
	{
		ID: 26,
		component: lazy(() => import("components/requestHandling/RequestHandling")),
		path: "/request-handling",
		functionCode: [
			"TM_SERVICE_REQUEST_MANAGEMENT",
			"MM_SERVICE_REQUEST_MANAGEMENT",
			"SM_SERVICE_REQUEST_MANAGEMENT",
		],
	},
	{
		ID: 20,
		component: lazy(() => import("components/serviceRequest/admin")),
		path: "/request-handling/:requestType",
		functionCode: [
			"TM_SERVICE_REQUEST_MANAGEMENT",
			"MM_SERVICE_REQUEST_MANAGEMENT",
			"SM_SERVICE_REQUEST_MANAGEMENT",
		],
	},
	{
		ID: 27,
		component: lazy(() => import("components/serviceRequest/researcher")),
		path: "/researcher-request",
		functionCode: ["TM_SERVICE_REQUEST", "MM_SERVICE_REQUEST", "SM_SERVICE_REQUEST"],
	},
	{
		ID: 19,
		component: lazy(() => import("components/serviceRequest/researcher")),
		path: "/researcher-request/:requestType",
		functionCode: ["TM_SERVICE_REQUEST", "MM_SERVICE_REQUEST", "SM_SERVICE_REQUEST"],
	},
	{
		ID: 29,
		component: lazy(() => import("components/dataServices/EXPERT/EXPERTLanding")),
		path: "/application-management/expertAudit",
		functionCode: ["APPLICATION_MANAGEMENT_EXPERT"],
	},
	{
		ID: 30,
		component: lazy(() => import("components/dataServices/EXPERTProject/EXPERTProject.page")),
		path: "/data-services/expertProject",
		functionCode: ["DATA_SERVICES_EXPERT"],
	},
	{
		ID: 31,
		component: lazy(() => import("components/dataServices/EXPERTProject/EXPERTProject.page")),
		path: "/project-management/expertProjectAudit",
		functionCode: ["APPLICATION_MANAGEMENT_EXPERT"],
	},
	{
		ID: 33,
		component: lazy(() => import("components/downloadZone/DownloadZone.page")),
		path: "/download-zone",
		functionCode: ["TM_PRIVATE_DOWNLOAD"],
	},
	{
		ID: 35,
		component: lazy(() => import("components/userProfile/UserProfileLanding")),
		path: "/userprofile",
		functionCode: ["TM_USER_PROFILE", "SM_USER_PROFILE"],
	},

	{
		ID: 36,
		component: lazy(() => import("components/template/index")),
		path: "/template",
		// functionCode: ["TM_USER_PROFILE", "SM_USER_PROFILE"],
		isCommonMenu: true,
	},
];

export default function DynamicPrivateRoutes(props) {
	const { user } = useContext(UserContext);

	const routes = () => {
		if (user) {
			return components.filter((c) => {
				if (c.isCommonMenu) return true;
				const isArray = Array.isArray(c.functionCode);
				const tempUserArr = [
					...user.functions,
					...user.menus.topMenus,
					...user.menus.middleMenus,
					...user.menus.siteMaps,
				];
				if (isArray) {
					return tempUserArr.some((f) => c.functionCode.indexOf(f.code) > -1);
				} else {
					return tempUserArr.some((f) => f.code === c.functionCode);
				}
			});
		}

		return [];
	};

	const HOMEPAGE = user?.homePage ?? "/homepage";

	return (
		<PrivateRoute>
			<Suspense
				fallback={
					<Grid
						style={{
							width: "100vw",
							height: "100vh",
						}}
						container
						alignItems="center"
						justifyContent="center"
					>
						<Button disabled>
							<CircularProgress size={24} />
						</Button>
					</Grid>
				}
			>
				<HomeLayout>
					<Route
						exact
						path="/"
						render={() => {
							return <Redirect to={HOMEPAGE} />;
						}}
					/>
					{routes().map((route) => (
						<PrivateRoute key={route.ID} exact path={route.path} component={route.component} />
					))}
				</HomeLayout>
			</Suspense>
		</PrivateRoute>
	);
}
